/**
 * @file FormSection.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of language to manage languages
 */
import React from "react";
import {
  Divider,
  Stack,
  TextField,
  Typography,
  Skeleton,
  Box,
  Switch,
} from "@mui/material";

export const FormSection = ({
  isLoading,
  register,
  errors,
  setValue,
  watch,
}) => {
  const isActive = watch("isactive");

  const handleSwitchChange = (event) => {
    setValue("isactive", event.target.checked ? 1 : 0);
  };

  return (
    <Box
      flex={1}
      height="100%"
      borderRadius="12px"
      px="8px"
      py={3}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
    >
      <Stack
        pb={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        {isLoading ? (
          <Skeleton variant="rounded" width={140} height={24} />
        ) : (
          <Typography fontWeight={500} fontSize={20} color="#222222">
            Enter details
          </Typography>
        )}
      </Stack>
      <Divider />
      <Box overflow="auto" pt={2}>
        {/* Name Field */}
        {isLoading ? (
          <Skeleton
            variant="rounded"
            sx={{ mt: 3, mb: 1 }}
            width={"100%"}
            height={40}
          />
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Typography>Language Name</Typography>
            <TextField
              placeholder="Enter language name"
              className="inputMdRounded"
              sx={{ bgcolor: "transparent" }}
              error={!!errors.languagename}
              helperText={
                errors.languagename ? errors.languagename.message : ""
              }
              {...register("languagename", {
                required: "Course name is required",
              })}
            />
          </Stack>
        )}

        {/* isActive Field */}
        {isLoading ? (
          <Skeleton
            variant="rounded"
            sx={{ mt: 3, mb: 1 }}
            width={"100%"}
            height={40}
          />
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Typography>Is Active ?</Typography>

            <Switch
              checked={isActive === 1}
              onChange={handleSwitchChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Stack>
        )}
      </Box>
    </Box>
  );
};
